import React from 'react';
import { DialogContentText } from '@mui/material';
import ConfirmationDialog from './ConfirmationDialog';

const VerificationPauseRescueConfirmationDialog = ({
  onCloseDialog,
  onResumeButtonClick,
  isSD = false,
  siteName = null,
}) => (
  <ConfirmationDialog
    dialogProps={{
      fullWidth: true,
    }}
    title="Resume rescuing"
    customMessage={
      isSD ? (
        <DialogContentText>
          Are you sure you want to resume rescuing for this user{siteName ? ` at ${siteName}` : ''}?
        </DialogContentText>
      ) : (
        <DialogContentText>Are you sure you want to resume rescuing at all of your sites?</DialogContentText>
      )
    }
    closeDialog={onCloseDialog}
    buttons={[
      { variant: 'outlined', label: 'Cancel', color: 'primary', onClick: onCloseDialog },
      { variant: 'contained', label: 'Resume rescuing', color: 'primary', onClick: onResumeButtonClick },
    ]}
  />
);

export default VerificationPauseRescueConfirmationDialog;
